/**
 * 请求地址统一处理／组装
 * @param {*} actionName action方法名称
 */

import projectConfig from '@/../config/project'
import { objectToQueryString } from '@/utils';

export default function (actionName) {
    if (actionName != null && actionName !== '') {
        if (actionName.substr(0, 1) === '/')
            actionName = actionName.substr(1);
    }
    return projectConfig.baseUrl + actionName;
}

export function buildGetUrl (actionName, params) {
    let queryString = objectToQueryString(params);
    if (actionName != null && actionName !== '') {
        if (actionName.substr(0, 1) === '/')
            actionName = actionName.substr(1);
    }

    return projectConfig.baseUrl + actionName + (queryString == null ? '' : ('?' + queryString));
}



// WEBPACK FOOTER //
// ./src/core/http/requestUrl.js